var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "8.848199844360352 6.437900066375732 30.30360221862793 35.12409973144531",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "   M28.5257,41.062H14.6869c-2.9485,0-5.3387-2.3902-5.3387-5.3387V12.2766c0-2.9485,2.3902-5.3387,5.3387-5.3387h13.8388   c2.9485,0,5.3387,2.3902,5.3387,5.3387v23.4468C33.8644,38.6718,31.4742,41.062,28.5257,41.062z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 15.8367,
    y1: 35.9957,
    x2: 19.2086,
    y2: 35.9957
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 15.8367,
    y1: 30.6099,
    x2: 21.6458,
    y2: 30.6099
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#536DFE",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "    M27.2195,23.5219L27.2195,23.5219c0,0.9401-0.8407,1.7021-1.8777,1.7021h-7.471c-1.037,0-1.8777-0.7621-1.8777-1.7021v0    c0-2.2717,2.0315-4.1132,4.5374-4.1132h2.1516C25.188,19.4087,27.2195,21.2503,27.2195,23.5219z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#536DFE",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 21.6063,
    cy: 14.6175,
    r: 2.8651
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#536DFE",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 32.1063,
    cy: 34.4939,
    r: 6.5455
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#536DFE",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "    29.5734,34.5242 31.2418,36.1926 34.6392,32.7951   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign-up.f413f77442e6c3084518541eea8ea3c9.svg";
export { ForwardRef as ReactComponent };